<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <a-form
        ref="form"
        :model="search"
        :style="{ marginBottom: '20px' }"
        :initialValues="search"
        :onFinish="pageSearchChange"
        layout="inline"
      >
        <a-form-item label="品牌商" name="brand">
          <a-input
            v-model:value="search.brand"
            style="width: 250px"
            placeholder="请输入品牌商编号/公司名称"
          ></a-input>
        </a-form-item>
        <a-form-item label="业务单号" name="billno">
          <a-input
            v-model:value="search.billno"
            style="width: 250px"
            placeholder="请输入微信业务单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="发放时间" name="">
          <a-select
            v-model:value="search.date"
            style="width:100px"
            @change="changDate"
          >
            <a-select-option value="1">自然日</a-select-option>
            <a-select-option value="7">自然周</a-select-option>
            <a-select-option value="30">自然月</a-select-option>
            <a-select-option value="">自定义</a-select-option>
          </a-select>
          <a-range-picker
            v-model:value="search.time"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
            @change="onChange"
          />
        </a-form-item>
        <a-form-item> </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit">搜索</a-button>
          <a-button class="ml-20" type="" htmlType="submit" v-has:exportSubstitution="exportTable"
          
            >导出</a-button
          >
          <a-button class="ml-20" type="" v-has:exportSubstitution="() => {exportListshow = true}" >查看生成列表</a-button>
        </a-form-item>
      </a-form>
      <a-col :span="4" class="mb-20">
        <a-card class="">
          <div class="s_flex_bian_c">
            <p>金额合计 (元)</p>
          </div>
          <p class="s_font_b fz-30 s_c000">{{ typeLits.grant_money }}</p>
        </a-card>
      </a-col>
      <a-table
        bordered
        :data-source="dataSource"
        :columns="columns"
        :pagination="false"
        rowKey="id"
        :loading="listLoading"
        class="tableFixBox"
        :scroll="{ x: 'max-content' }"
      >
        <template #balance>
          <span style="display: flex;">
            <div class="mt-5"> 红包金额</div>
            <span class="ml-10" style="display: flex; flex-direction: column;">
              <span style="margin-bottom: -12px;">
                <CaretUpOutlined @click="sort(1)" :style="{ fontSize: '14px', color: isClicked ? '#05486a' : '#bfbfbf'}" />
              </span>
              <span style="margin-bottom: -12px;">
                <CaretDownOutlined @click="sort(2)" :style="{ fontSize: '14px', color: isClicked ? '#bfbfbf' : '#05486a' }" />
              </span>
            </span>
          </span>
        </template>
      </a-table>
      <a-pagination
        :style="{ marginTop: '20px', textAlign: 'right' }"
        show-size-changer
        show-quick-jumper
        :current="search.page"
        :page-size="search.limit"
        :total="total"
        @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"
        :show-total="(total) => `总数: ${total} `"
      />
    </a-card>
     <a-modal
      :keyboard="false"
      title="查看报表"
      v-model:visible="exportListshow"
      centered
      :footer="null"
      :width="1000"
      destroyOnClose
    >
      <warehousTable :type="2"></warehousTable>
    </a-modal>
  </a-layout>
</template>

<script>
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import {
  allBrandbehalfLog,
  allBrandBillConsumeGeneral
} from "@/api/financial";
import { $iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { useTime } from "@/hooks/useTime";
import warehousTable from "./warehousTable"
import config from "@/config";
let defSearch = {
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
  date: "1",
  time: [],
  brand: "",
  billno: "",
  sort_balance: ""
};
export default {
  name: "agentList",
  components: { CaretUpOutlined, CaretDownOutlined,warehousTable},
  setup(props) {
    let search = ref({ ...defSearch });
    let total = ref(1);
    const state = reactive({
      typeLits: {},
      dataSource: [],
      listLoading: false,
      isClicked: false,
      exportListshow: false,
      columns: [
        {
          title: "微信业务单号",
          dataIndex: "billno",
        },
        {
          dataIndex: "balance",
          key: "balance",
          slots: { title: "balance", customRender: "balances" },
        },
        {
          title: "发放时间",
          dataIndex: "create_time",
        },
        {
          title: "品牌商编号",
          dataIndex: "brand_no",
        },
        {
          title: "公司名称",
          dataIndex: "brand_company",
        },
      ],
    });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
      getType(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.limit = size;
      initData(search.value);
    };
    // 导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await allBrandbehalfLog({ ...search.value, is_export: 1 })
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(result)) {
        message.success("生成成功，请在生成列表中查看");
      }
      setTimeout(hide);
    };
    const getType = async () => {
      let res = await allBrandBillConsumeGeneral({ ...search.value }).then((res) => res.data);
      if ($iscode(res)) {
        state.typeLits = res.data;
      } else {
        message.error(res.msg);
      }
    };

    //列表
    const initData = async () => {
      state.listLoading = true;
      try {
        let res = await allBrandbehalfLog({
          ...search.value,
        }).then((res) => res.data);
        state.listLoading = false;
        if ($iscode(res)) {
          state.dataSource = res.data.data;
          total.value = res.data.total;
        } else {
          message.error(res.message);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };

    // 切换时间类型
    // var $moment = inject("momentTime");
    const { typeToStartEnd, dateTargets } = useTime();
    const changDate = (e) => {
      var { start_time, end_time } = typeToStartEnd(e);
      search.value.start_time = start_time;
      search.value.end_time = end_time;
      search.value.time = [start_time, end_time];
      if (e == "month" || e == "year") {
        search.value.dateTarget = dateTargets(e);
      }
      initData();
      getType();
    };
    const  sort = (e) =>{
      state.isClicked = !state.isClicked;
      search.value.sort_balance = e
      initData(search.value);
    }
    onMounted(() => {
      changDate("1");
      getType();
    });
    return {
      ...toRefs(state),
      initData,
      search,
      total,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      exportTable,
      changDate,
      sort
    };
  },
};
</script>

<style lang="less"></style>
